import { useEffect, useRef, useState } from "react"
import { toast } from "react-toastify"
import { getEnv } from "../../../config"
import { useAuth0 } from "@auth0/auth0-react"
import { EventSource } from "extended-eventsource"

export function useFetchUnreadCount(imo: string, orgId: string) {
  const [unreadCount, setUnreadCount] = useState<number>(0)
  const [isSSEConnected, setIsSSEConnected] = useState<boolean>(false)
  const prevCountRef = useRef<number>(0)
  const eventSourceRef = useRef<EventSource | null>(null)
  const { getAccessTokenSilently, user } = useAuth0()

  useEffect(() => {
    let es: EventSource | null = null

    async function setupSSE() {
      if (!imo) return

      try {
        const baseURL = (getEnv("REACT_APP_SERVERAPIURL") as string)?.trim()
        const token = await getAccessTokenSilently()

        const url = `${baseURL}/api/v1/prevetting/logs/unread?imo=${imo}&orgId=${orgId}`

        es = new EventSource(url, {
          headers: {
            Authorization: `Bearer ${token}`,
            "X-Request-ID": user?.sub || "",
          },
        })

        eventSourceRef.current = es

        es.onopen = () => {
          setIsSSEConnected(true)
        }

        es.onmessage = (e) => {
          try {
            const data = JSON.parse(e.data) as number

            if (data > prevCountRef.current) {
              toast.info(`New log available for vessel ${imo}`, {
                position: "bottom-right",
                autoClose: 3000,
              })
            }

            prevCountRef.current = data
            setUnreadCount(data)
          } catch (err) {
            console.error("Error parsing SSE data", err)
          }
        }

        es.onerror = (err) => {
          console.warn("SSE connection error", err)
          setIsSSEConnected(false)
          es?.close()
        }
      } catch (err) {
        console.error("Error setting up SSE", err)
      }
    }

    setupSSE()

    return () => {
      es?.close()
    }
  }, [imo, getAccessTokenSilently, user?.sub])

  return {
    unreadCount,
    isSSEConnected,
  }
}